import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home'
import Login from '@/views/auth/Login'
import Register from '@/views/auth/Register'
import Gradients from '@/views/gradients/GradientsCatalog'
import Gradient from '@/views/gradients/Gradient'
import Palettes from '@/views/palettes/Catalog'
import Palette from '@/views/palettes/Palette'
import GradientGenerator from '@/views/tools/GradientGenerator'
import RandomColor from "@/views/tools/RandomColor";
import ColorPicker from "@/views/tools/ColorPicker";
import Color from "@/views/tools/Color";
import Privacy from "@/views/more/Privacy";
import Terms from "@/views/more/Terms";
import Cookies from "@/views/more/Cookies";
import Pricing from "@/views/more/Pricing";
import Team from "@/views/more/Team";
import WhatsNew from "@/views/more/WhatsNew";
import GradientsPanel from "@/views/admin/GradientsPanel";
import PalettesPanel from "@/views/admin/PalettesPanel";
import FormNewGradient from "@/views/admin/gradients/FormNewGradient";
import FormEditGradient from "@/views/admin/gradients/FormEditGradient";
import FormNewPalette from "@/views/admin/palettes/FormNewPalette";
import FormEditPalette from "@/views/admin/palettes/FormEditPalette";
import Profile from "@/views/users/Profile";
import PageNotFound from "@/views/error/404";
import UserGradients from "@/views/users/gradients/UserGradients";
import UserGradient from "@/views/users/gradients/UserGradient";
import GradientsLiked from "@/views/users/gradients/GradientsLiked";
import PalettesLiked from "@/views/users/palettes/PalettesLiked";
import Welcome from "@/views/users/Welcome";
import ForgotPassword from "@/views/auth/ForgotPassword";
import firebase from 'firebase/app'
import 'firebase/auth'
import GradientPicture from "@/views/gradients/GradientPicture";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },

    {
        path: '*',
        name: 'PageNotFound',
        component: PageNotFound,
    },

    {
        path: '/welcome',
        name: 'Welcome',
        component: Welcome,
        meta: {requireAuth: true}
    },

    //---------- AUTH ROUTES ----------//
    {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: {guestOnly: true}
    },
    {
        path: '/sign-up',
        name: 'Register',
        component: Register,
        meta: {guestOnly: true}
    },
    {
        path: '/forgot-password',
        name: 'ForgotPassword',
        component: ForgotPassword,
        meta: {guestOnly: true}
    },

    //---------- USER ROUTES ----------//
    {
        path: '/profile',
        name: 'Profile',
        component: Profile,
        meta: {requireAuth: true}
    },
    {
        path: '/user/gradients',
        name: 'UserGradients',
        component: UserGradients,
        meta: {requireAuth: true}
    },
    {
        path: '/user/:userId/gradients/:gradientId',
        name: 'UserGradient',
        component: UserGradient,
        meta: {requireAuth: true}
    },
    {
        path: '/user/likes/gradients',
        name: 'LikedGradients',
        component: GradientsLiked,
        meta: {requireAuth: true}
    },
    {
        path: '/user/likes/palettes',
        name: 'LikedPalettes',
        component: PalettesLiked,
        meta: {requireAuth: true}
    },
    /*{
        path: '/user/palettes',
        name: 'UserPalettes',
        component: UserPalettes,
        meta: {requireAuth: true}
    },*/

    //---------- COLORS ROUTES ----------//
    {
        path: '/gradients',
        name: 'Gradients',
        component: Gradients
    },
    {
        path: '/gradients/:gradientId',
        name: 'Gradient',
        component: Gradient
    },
    {
        path: '/gradients/:gradientId/picture',
        name: 'GradientPicture',
        component: GradientPicture
    },
    {
        path: '/palettes',
        name: 'Palettes',
        component: Palettes
    },
    {
        path: '/palettes/:paletteId',
        name: 'Palette',
        component: Palette
    },

    //---------- ADMIN ROUTES ----------//
    {
        path: '/admin/gradients',
        name: 'GradientsPanel',
        component: GradientsPanel,
        meta: {requireAuth: true}
    },
    {
        path: '/admin/gradients/create',
        name: 'FormNewGradient',
        component: FormNewGradient,
        meta: {requireAuth: true}
    },
    {
        path: '/admin/gradients/edit/:gradientId',
        name: 'FormEditGradient',
        component: FormEditGradient,
        meta: {requireAuth: true}
    },

    {
        path: '/admin/palettes',
        name: 'PalettesPanel',
        component: PalettesPanel,
        meta: {requireAuth: true}
    },
    {
        path: '/admin/palettes/create',
        name: 'FormNewPalette',
        component: FormNewPalette,
        meta: {requireAuth: true}
    },
    {
        path: '/admin/palettes/edit/:paletteId',
        name: 'FormEditPalette',
        component: FormEditPalette,
        meta: {requireAuth: true}
    },

    //---------- TOOLS ROUTES ----------//
    {
        path: '/gradient/generator',
        name: 'GradientGenerator',
        component: GradientGenerator
    },
    {
        path: '/random-color',
        name: 'RandomColor',
        component: RandomColor
    },
    {
        path: '/color-image-picker',
        name: 'ColorImagePicker',
        component: ColorPicker
    },
    {
        path: '/color',
        name: 'Color',
        component: Color
    },

    //---------- OLD ROUTES REDIRECT TO NEW ONES ----------//
    {
        path: '/gradients/catalog',
        redirect: '/gradients'
    },
    {
        path: '/palettes/catalog',
        redirect: '/palettes'
    },
    {
        path: '/generator/mgradients',
        redirect: '/gradient/generator'
    },
    {
        path: '/generator/gradients',
        redirect: '/gradient/generator'
    },

    //---------- MORE ROUTES ----------//
    {
        path: '/privacy',
        name: 'Privacy',
        component: Privacy
    },
    {
        path: '/pricing',
        name: 'Pricing',
        component: Pricing
    },
    {
        path: '/terms',
        name: 'Terms',
        component: Terms
    },
    {
        path: '/cookies',
        name: 'Cookies',
        component: Cookies
    },
    {
        path: '/team',
        name: 'Team',
        component: Team
    },
    {
        path: '/whats-new',
        name: 'WhatsNew',
        component: WhatsNew
    },

]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior() {
        return {x: 0, y: 0}
    }
})

router.beforeEach(async (to, from, next) => {
    // const loggedIn = store.getters.user.loggedIn
    const requireAuth = to.matched.some(record => record.meta.requireAuth)
    const guestOnly = to.matched.some(record => record.meta.guestOnly)
    const firebaseUser = firebase.auth().currentUser

    if (requireAuth && !firebaseUser) next('login')
    else if (guestOnly && firebaseUser) next('profile')
    else next()
})

export default router
